import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	componentName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	componentLead: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	componentLeadPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	defaultAssignee: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deactivated: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	requiredFieldsInformMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	componentName: {
		id: 'project-components.edit-modal-dialog-component-name-label',
		defaultMessage: 'Name',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	componentLead: {
		id: 'project-components.edit-modal-dialog-component-lead-label',
		defaultMessage: 'Component lead',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	componentLeadPlaceholder: {
		id: 'project-components.edit-modal-dialog-component-lead-placeholder',
		defaultMessage: 'Select person',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	description: {
		id: 'project-components.edit-modal-dialog-description-label',
		defaultMessage: 'Description',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	defaultAssignee: {
		id: 'project-components.edit-modal-dialog-default-assignee-label',
		defaultMessage: 'Default assignee',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	deactivated: {
		id: 'project-components.edit-modal-dialog-deactivated-status-label',
		defaultMessage: '{userName} (Deactivated)',
		description:
			'Text displayed to the right of the user name of a deactivated user in user picker field',
	},
	requiredFieldsInformMessage: {
		id: 'project-components.edit-modal-dialog-required-field-inform-text-message',
		defaultMessage: 'Required fields are marked with an asterisk',
		description: 'Message to give information to users about required fields',
	},
});
export default messages;
